import { render, staticRenderFns } from "./IntraoralMenu.vue?vue&type=template&id=ef162426&scoped=true&"
import script from "./IntraoralMenu.vue?vue&type=script&lang=js&"
export * from "./IntraoralMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef162426",
  null
  
)

export default component.exports